import { render, staticRenderFns } from "./controle.vue?vue&type=template&id=5503a2d0"
import script from "./controle.vue?vue&type=script&lang=js"
export * from "./controle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports